import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var PageDivider = function PageDivider(_ref) {
  var isVisuallyHidden = _ref.isVisuallyHidden,
      pageNumber = _ref.pageNumber,
      title = _ref.title,
      uniqueName = _ref.uniqueName;
  var id = getPageID(uniqueName, pageNumber);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "screen-reader-text",
      children: title
    }), !isVisuallyHidden && /*#__PURE__*/jsxs("span", {
      className: "page-divider__wrapper",
      id: id,
      tabIndex: -1,
      "aria-hidden": true,
      "data-auto": "page-divider",
      children: [/*#__PURE__*/jsx("span", {
        className: "page-divider__title",
        title: title,
        children: pageNumber
      }), /*#__PURE__*/jsx("hr", {
        className: "page-divider"
      })]
    })]
  });
};

var getPageID = function getPageID(uniqueName, pageNumber) {
  return "".concat(uniqueName, "-page-").concat(pageNumber);
};

var Page = function Page(_ref) {
  var children = _ref.children,
      number = _ref.number,
      title = _ref.title,
      uniqueName = _ref.uniqueName;
  var isFirstPage = number === 0;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(PageDivider, {
      isVisuallyHidden: isFirstPage,
      pageNumber: number + 1,
      title: title,
      uniqueName: uniqueName
    }), children]
  });
};

Page.getPageID = getPageID;

export { Page as default };
//# sourceMappingURL=page-esm.js.map
